module.exports = __webpack_public_path__ + "fonts/Sen-Regular.861a3824.eot";